import React, { Component } from 'react';

import { reduxForm } from 'redux-form';

import withAuthControl from '../auth/Auth.js';

import Section from './Section.js';
import CustomSpinner from './CustomSpinner.js';
import CustomAlertModal from './CustomAlertModal.js';
import RenaperAddFront from './RenaperAddFront.js';
import RenaperAddTramitNumber from './RenaperAddTramitNumber'
import RenaperAddBack from './RenaperAddBack.js';
import RenaperScanDocumentTips from './RenaperScanDocumentTips.js';

require(`../assets/${process.env.PAGE}/css/renaper.css`);

const RENAPER_STEPS = [
  'addTramitNumber',
  'addBack',
  'addFront',
  'scanDocumentTips',
];

class RenaperDni extends Component {
  constructor(props){
    super(props);

    this.state = {
        attempt: 1,
        processedSteps: [],
        currentStep: RENAPER_STEPS.pop(),
        missingSteps: [...RENAPER_STEPS],
        incompatibleSettings: false,
    }

    this.resetSteps = this.resetSteps.bind(this);
    this.updateStep = this.updateStep.bind(this);
    this.checkBrowserCompatibility = this.checkBrowserCompatibility.bind(this);
  }

  componentDidMount(){
    let body = document.getElementsByTagName("BODY")[0];
    body.style.position = "fixed";
    this.checkBrowserCompatibility();
  }

  componentWillUnmount(){
    let body = document.getElementsByTagName("BODY")[0];
    body.style.position = "inherit";
  }

  updateStep(){
    let { currentStep, missingSteps, processedSteps } = this.state;
    this.setState({
      ...this.state,
      processedSteps:[
        ...processedSteps,
        currentStep,
      ],
    });

    if(missingSteps.length === 0){
      this.props.dispatch(this.props.getStep({}, this.props.dispatch));
    }

    this.setState({
      ...this.state,
      currentStep: missingSteps.pop(),
      missingSteps: [
        ...missingSteps
      ]
    });
  }

  checkBrowserCompatibility(){
    if(/iPhone|iPad/.test(navigator.userAgent)){
      if(!/Version\//.test(navigator.userAgent)){
        this.setState({
          ...this.state,
          incompatibleSettings: true,
        })
      }
    }
  }

  resetSteps(){
    this.setState({
      attempt: this.state.attempt + 1,
      processedSteps: [],
      currentStep: 'scanDocumentTips',
      missingSteps: [...RENAPER_STEPS],
    });

    this.props.dispatch(this.props.getStep({}, this.props.dispatch));
  }

  render() {
    const { currentStep, incompatibleSettings, attempt } = this.state;

    let stepComponent = null;


    switch(currentStep){
      case('scanDocumentTips'):
          stepComponent = (<RenaperScanDocumentTips onFinish={this.updateStep}/>)
          break;
      case('addFront'):
          stepComponent = (<RenaperAddFront onFinish={this.updateStep} onRollback={this.resetSteps} key={attempt}/>)
          break;
      case('addBack'):
          stepComponent = (<RenaperAddBack onFinish={this.resetSteps} onRollback={this.state.attempt >= 1 ? this.updateStep : this.resetSteps} key={attempt}/>)
          break;
      case('addTramitNumber'):
          stepComponent = (<RenaperAddTramitNumber onFinish={this.updateStep} onRollback={this.resetSteps} key={attempt}/>)
          break;
      default:
          stepComponent = '';
    }

    return (
    <Section className="intro_form">
        {this.props.isLoading && <CustomSpinner message='Estamos buscando tu auto ideal' /> }
        <div className="row">
          <div className="pd-content-left col-md-12 col-lg-12 text-center">
            <p>Coloca tus datos como figuran en el DNI.</p>
          </div>
        </div>
        <div className="row">
            <div className="pd-content-right col-sm-12 col-md-12 col-lg-12">
                <form  className="pvc-form">
                    <div style={{
                        position: "fixed",
                        left: 0,
                        top: 0,
                        height: "100vh",
                        width: "100%",
                        background: "#000",
                        zIndex: "1000"
                    }} >
                        {stepComponent}
                        {incompatibleSettings && (<CustomAlertModal>
                          Para poder acceder a la cámara de su dispositivo necesitamos que por favor reingrese desde Safari
                        </CustomAlertModal>)}
                    </div>
                </form>
            </div>
        </div>
    </Section>)

  }
}


RenaperDni = reduxForm({
    form: 'RenaperDni', // a unique name for this form
})(RenaperDni);

RenaperDni = withAuthControl(RenaperDni);

export default RenaperDni;



/** WEBPACK FOOTER **
 ** ./src/components/RenaperDni.js
 **/